/**
 * Guide article navigation (markup: snippets/tft-guide-article-shell.liquid).
 *
 * - Bar (below 1200px) and sidebar (1200px and up) appear once the article's
 *   title band has scrolled away, and the sidebar steps aside again when the
 *   article ends so it never sits over "Continue Reading" or the footer.
 * - Contents opens the guide list in a <dialog> drawer (Escape and backdrop
 *   close it; focus is handled by the dialog itself).
 * - The current article's own headings are listed under it, with the section
 *   being read highlighted.
 */
(function () {
  'use strict';
  var nav = document.querySelector('[data-guide-nav]');
  if (!nav) return;

  var bar = nav.querySelector('[data-guide-bar]');
  var rail = nav.querySelector('[data-guide-rail]');
  var drawer = document.getElementById('guideDrawer');
  var header = document.querySelector('.article-header');
  var body = document.querySelector('.article-body');
  var root = document.documentElement;
  var wide = window.matchMedia('(min-width: 1200px)');

  root.classList.add('has-guide-nav');

  // ---- On-page contents ---------------------------------------------------
  var heads = Array.prototype.slice.call(document.querySelectorAll('.article-content h2[id]'))
    .filter(function (h) { return h.id !== 'references'; });
  Array.prototype.forEach.call(nav.querySelectorAll('[data-guide-toc]'), function (list) {
    heads.forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
  });

  var lastId;
  function markCurrent(id) {
    if (id === lastId) return;
    lastId = id;
    Array.prototype.forEach.call(nav.querySelectorAll('[data-guide-toc] a'), function (a) {
      var on = a.getAttribute('href') === '#' + id;
      a.classList.toggle('is-current', on);
      if (on) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
    });
    keepInView();
  }

  // Scroll the sidebar (never the page) so the current article, and the
  // section being read under it, stay visible in long guides.
  function keepInView() {
    if (!rail || !rail.classList.contains('is-visible')) return;
    var target = rail.querySelector('[data-guide-toc] a.is-current') || rail.querySelector('[aria-current="page"]');
    if (!target) return;
    var r = rail.getBoundingClientRect(), t = target.getBoundingClientRect();
    var margin = 48;
    if (t.top < r.top + margin || t.bottom > r.bottom - margin) {
      rail.scrollTop += (t.top - r.top) - r.height / 3;
    }
  }

  // ---- Show / hide ----------------------------------------------------------
  // Scroll position from layout, not window.scrollY: robust whichever
  // element ends up scrolling (html, body, or a mobile emulator's viewport).
  function scrollPos() { return -document.body.getBoundingClientRect().top; }
  var lastY = scrollPos();
  var ticking = false;

  function headerOffset() {
    var h = document.querySelector('.header');
    return h ? h.getBoundingClientRect().bottom : 0;
  }

  function update() {
    ticking = false;
    var y = scrollPos();
    var top = headerOffset();
    var pastHeader = header ? header.getBoundingClientRect().bottom < top + 8 : y > 200;
    var bodyRect = body ? body.getBoundingClientRect() : null;

    // bar: below 1200px, stays put once the title band has scrolled away
    var showBar = pastHeader && !wide.matches;
    if (bar) {
      bar.classList.toggle('is-visible', showBar);
      bar.setAttribute('aria-hidden', showBar ? 'false' : 'true');
    }

    // sidebar: 1200px and up, while the article body fills the rail's space
    if (rail) {
      var railH = rail.offsetHeight;
      var showRail = wide.matches && pastHeader && bodyRect && bodyRect.bottom > top + railH + 64;
      var wasVisible = rail.classList.contains('is-visible');
      rail.classList.toggle('is-visible', !!showRail);
      if (showRail && !wasVisible) keepInView();
    }

    // scroll spy: the last heading above the reading line
    var line = top + 120, current = null;
    for (var i = 0; i < heads.length; i++) {
      if (heads[i].getBoundingClientRect().top <= line) current = heads[i].id; else break;
    }
    markCurrent(current);
    lastY = y;
  }

  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll);
  if (wide.addEventListener) wide.addEventListener('change', onScroll);
  update();

  // ---- Drawer ---------------------------------------------------------------
  var openBtn = nav.querySelector('[data-guide-open]');
  var closeBtn = drawer && drawer.querySelector('[data-guide-close]');
  if (drawer && typeof drawer.showModal === 'function') {
    openBtn && openBtn.addEventListener('click', function () {
      drawer.showModal();
      var cur = drawer.querySelector('[aria-current="page"]');
      if (cur) cur.scrollIntoView({ block: 'center' });
    });
    closeBtn && closeBtn.addEventListener('click', function () { drawer.close(); });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) drawer.close();                   // backdrop
      if (e.target.closest && e.target.closest('a')) drawer.close(); // followed a link
    });
  } else if (openBtn) {
    // no <dialog> support: fall back to the hub page
    openBtn.addEventListener('click', function () {
      var hub = nav.querySelector('.guide-bar-back');
      if (hub) window.location.href = hub.href;
    });
  }
})();
